// extracted by mini-css-extract-plugin
export default {"accessServer_wrapper":"SharePhotoModal_accessServer_wrapper__bZ0o-"};